<template>
  <Teleport to="body">
    <Transition name="modal">
      <div class="modal-overlay" @click="close">
        <div class="auth-form" @click.stop>
          <div class="auth-form__content">
            <div class="auth-form__header">
              <h1 class="auth-form__title">Қош келдіңіз!</h1>
              <p class="auth-form__subtitle">Жүйеге қосылыңыз</p>
            </div>

            <div class="auth-form__tabs">
              <button
                v-for="tab in tabs"
                :key="tab.value"
                class="auth-form__tab"
                :class="{ 'auth-form__tab--active': tab.value === activeTab }"
                @click="activeTab = tab.value"
              >
                {{ tab.label }}
              </button>
            </div>

            <div class="auth-form__fields">
              <div class="auth-form__field">
                <input
                  type="email"
                  placeholder="E-mail"
                  class="auth-form__input"
                />
              </div>
              <template v-if="activeTab === 'register'">
                <div class="auth-form__field">
                  <input
                    type="text"
                    placeholder="Аты жөні"
                    class="auth-form__input"
                  />
                </div>
                <div class="auth-form__field">
                  <input
                    type="tel"
                    placeholder="Байланыс нөмері"
                    class="auth-form__input"
                  />
                </div>
              </template>
              <div class="auth-form__field">
                <input
                  type="password"
                  placeholder="Құпия сөз"
                  class="auth-form__input"
                />
              </div>
            </div>

            <button class="auth-form__submit">
              {{ activeTab === "login" ? "Кіру" : "Тіркелу" }}
            </button>
          </div>
          <button class="auth-form__close" @click="close">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M19.75 4.25L4.25 19.75M4.25 4.25L19.75 19.75"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
export default {
  name: "AuthForm",
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      activeTab: "login",
      tabs: [
        {
          label: "Кіру",
          value: "login",
        },
        {
          label: "Тіркелу",
          value: "register",
        },
      ],

      form: {
        email: "",
        name: "",
        phone: "",
        password: "",
      },
    };
  },
  methods: {
    close() {
      this.$emit("closeAuthForm");
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  @apply fixed top-0 left-0 w-full h-full bg-black/50 flex justify-center items-center z-50;
}

.auth-form {
  @apply relative bg-white rounded-2xl p-6 max-w-[400px] w-full;
}

.auth-form__content {
  @apply flex flex-col gap-8;
}

.auth-form__header {
  @apply flex flex-col gap-1;
}

.auth-form__title {
  @apply text-xl font-semibold text-black;
}

.auth-form__subtitle {
  @apply text-base text-gray-500;
}

.auth-form__tabs {
  @apply flex gap-2 bg-gray-100 rounded-lg p-1;
}

.auth-form__tab {
  @apply flex-1 p-2 border-none bg-transparent rounded-lg text-sm text-black;
  cursor: pointer;
  &.auth-form__tab--active {
    @apply bg-[#FDC903] text-black;
  }
}

.auth-form__fields {
  @apply flex flex-col gap-4;
}

.auth-form__field {
  @apply w-full;
}

.auth-form__input {
  @apply w-full h-12 bg-gray-100 border-none rounded-lg p-4 text-base text-black;
}

.auth-form__input::placeholder {
  @apply text-gray-500;
}

.auth-form__submit {
  @apply w-full h-12 bg-[#058242] border-none rounded-lg text-white text-sm;
  cursor: pointer;
}

.auth-form__close {
  @apply absolute top-4 right-4 bg-transparent border-none p-0 cursor-pointer text-gray-500;
  &:hover {
    @apply text-gray-700;
  }

  svg {
    @apply w-5 h-5;
  }
}

/* Анимации */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-active .auth-form,
.modal-leave-active .auth-form {
  transition: transform 0.3s ease;
}

.modal-enter-from .auth-form,
.modal-leave-to .auth-form {
  transform: scale(0.95);
}
</style>
